import { Sparkles, Car, Gem, Sofa, PenLine } from "lucide-react";
import { OptionCard, StepError } from "./WizardBits";

const ICONS = { interior: Sparkles, exterior: Car, complete: Gem, sofa: Sofa, other: PenLine };
export const SERVICE_KEYS = ["interior", "exterior", "complete", "sofa", "other"];

export const StepService = ({ c, w }) => (
  <div>
    <div role="radiogroup" aria-label={c.stepTitles[0]} className="grid sm:grid-cols-2 gap-3 md:gap-4">
      {SERVICE_KEYS.map((k) => (
        <div key={k} className={k === "other" ? "sm:col-span-2" : ""}>
          <OptionCard
            testid={`wizard-service-${k}`}
            selected={w.data.service === k}
            onClick={() => w.set("service", k)}
            icon={ICONS[k]}
            title={c.services[k].title}
            desc={c.services[k].desc}
          />
        </div>
      ))}
    </div>
    <StepError text={w.errors.service} testid="wizard-error-service" />
  </div>
);
